import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import BusinessIcon from '@material-ui/icons/Business';

const useStyles = makeStyles((theme) => ({
  sectionHeader: {
    margin: '0.3rem 0',
  },
  text: {
    marginTop: '-0.2rem',
  },
  section: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const ContactInfo = () => {
  const classes = useStyles();
  return (
    <div>
      <div style={{ marginTop: '0.3rem' }} className={classes.section}>
        <BusinessIcon style={{ marginRight: '0.3rem' }} fontSize="small" />
        <p className={classes.sectionHeader}>Юр./Почтовый адрес:</p>
      </div>
      <p className={classes.text}>236022, Калининград, Грекова 11 - 2</p>
      <div className={classes.section}>
        <BusinessIcon style={{ marginRight: '0.3rem' }} fontSize="small" />
        <p className={classes.sectionHeader}>Офис:</p>
      </div>
      <p className={classes.text}>
        236006, Калининград, Ленинский проспект 30А, офис 612.
      </p>
      <div className={classes.section}>
        <PhoneIcon style={{ marginRight: '0.3rem' }} fontSize="small" />
        <p> Телефон:</p>
      </div>
      <p className={classes.text}>8 (4012) 530-206</p>
      <div className={classes.section}>
        <PhoneIcon style={{ marginRight: '0.3rem' }} fontSize="small" />
        <p> Телефон:</p>
      </div>
      <p className={classes.text}>8 (4012) 530-205</p>

      <div className={classes.section}>
        <EmailIcon style={{ marginRight: '0.3rem' }} fontSize="small" />
        <p className={classes.sectionHeader}>Почта:</p>
      </div>
      <p className={classes.text}>georu39@gmail.com</p>
    </div>
  );
};
export default ContactInfo;
